import { Briefcase, Share2, Hotel, HeartPulse, Sparkles, Boxes } from "lucide-react";

/**
 * Configurazione GRAFICA opzionale per slug conosciuti (icona + immagine + image_key admin).
 * La PRESENZA della categoria dipende SEMPRE dal backend: questa è solo estetica.
 * Slug sconosciuti (es. "utility") ricevono un fallback elegante coerente col brand.
 */
const GRAPHICS = {
  career: { Icon: Briefcase, img: "/category-backgrounds/category-career.webp", editKey: "category_career" },
  "business-social": { Icon: Share2, img: "/category-backgrounds/category-business-social.webp", editKey: "category_business_social" },
  hospitality: { Icon: Hotel, img: "/category-backgrounds/category-hospitality.webp", editKey: "category_hospitality" },
  oss: { Icon: HeartPulse, img: "/category-backgrounds/category-oss.webp", editKey: "category_oss" },
  digitale: { Icon: Sparkles, img: "https://images.pexels.com/photos/30547616/pexels-photo-30547616.jpeg", editKey: "category_digitale" },
  utility: { Icon: Boxes, img: null, editKey: null },
};

const FALLBACK = { Icon: Boxes, img: null, editKey: null };

export function categoryGraphics(slug) {
  return GRAPHICS[slug] || FALLBACK;
}

export default categoryGraphics;
